import { render, staticRenderFns } from "./AutomationFileInput.vue?vue&type=template&id=4c0ed709&scoped=true&"
import script from "./AutomationFileInput.vue?vue&type=script&lang=js&"
export * from "./AutomationFileInput.vue?vue&type=script&lang=js&"
import style0 from "./AutomationFileInput.vue?vue&type=style&index=0&id=4c0ed709&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0ed709",
  null
  
)

export default component.exports